
import { IField } from "../../../types/Form/IForm";
import { isDate } from "../../../utils/utils";

export default function dateFieldValidator(field: IField) {

    if (!field.VALUES || field.VALUES.length === 0 || !field.VALUES[0] || !isDate(new Date(field.VALUES[0])))
        return `*required`
}